<app-cart [selectedCustomer]="selectedCustomer"
          [selectedProducts]="selectedProducts"
          [disableOrder]="true"
          [disableEdit]="true"
          [disableDelete]="true"
          [disableDraft]="true">
</app-cart>
